import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

const BORDER_COLOR = "#000000";
const BORDER_WIDTH = 1;

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
  },
  title: {
    fontSize: 24,
    marginBottom: 10,
    textAlign: "center",
    fontWeight: "extrabold",
  },
  tableContainer: {
    borderWidth: BORDER_WIDTH,
    borderColor: BORDER_COLOR,
    borderStyle: "solid",
    marginTop: 10,
  },
  header: {
    flexDirection: "row",
    backgroundColor: "#E0E0E0",
    alignItems: "center",
    height: 28,
    textAlign: "center",
    borderBottomWidth: BORDER_WIDTH,
    borderBottomColor: BORDER_COLOR,
    borderBottomStyle: "solid",
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    height: 30,
  },

  columnStyleBase: {
    borderRightColor: BORDER_COLOR,
    borderRightWidth: BORDER_WIDTH,
    borderRightStyle: "solid",
    height: "100%",
    paddingVertical: 2,
    justifyContent: "center",
  },

  sn: { width: "6%", textAlign: "center", justifyContent: "center" },
  billNo: {
    width: "14%",
    textAlign: "center",
    justifyContent: "center",
    paddingLeft: 5,
  },
  partyName: { width: "26%", textAlign: "center", paddingLeft: 5 },
  gstNo: { width: "17%", textAlign: "center", paddingLeft: 5 },
  billAmount: { width: "16%", textAlign: "center", paddingRight: 5 },
  gstAmount: { width: "16%", textAlign: "center", paddingRight: 5 },
  toAmount: {
    width: "15%",
    textAlign: "center",
    paddingRight: 5,
    borderRightWidth: 0,
  },

  headerText: {
    fontWeight: "bold",
    fontSize: 14,
  },
});

const SalesInvoicePdfList = ({ data }) => {
  const getColumnStyle = (styleKey, isLast = false) => {
    const baseStyle = styles[styleKey];
    return isLast ? baseStyle : [baseStyle, styles.columnStyleBase];
  };

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <Text style={styles.title}>Sales Report</Text>

        <View style={styles.tableContainer}>
          <View style={styles.header} fixed>
            <Text style={[getColumnStyle("sn"), styles.headerText]}>S.NO</Text>
            <Text style={[getColumnStyle("billNo"), styles.headerText]}>
              Bill Number
            </Text>
            <Text style={[getColumnStyle("partyName"), styles.headerText]}>
              Party Name
            </Text>
            <Text style={[getColumnStyle("gstNo"), styles.headerText]}>
              GST Number
            </Text>
            <Text style={[getColumnStyle("billAmount"), styles.headerText]}>
              Bill Amount
            </Text>
            <Text style={[getColumnStyle("gstAmount"), styles.headerText]}>
              GST Amount
            </Text>
            <Text style={[getColumnStyle("toAmount", true), styles.headerText]}>
              Total Amount
            </Text>
          </View>

          {data.map((item, index) => (
            <View
              style={[
                styles.row,
                index < data.length - 1
                  ? {
                      borderBottomColor: BORDER_COLOR,
                      borderBottomWidth: BORDER_WIDTH,
                      borderBottomStyle: "solid",
                    }
                  : {},
              ]}
              key={index}
            >
              <Text style={getColumnStyle("sn")}>{item.s_no || index + 1}</Text>
              <Text style={getColumnStyle("billNo")}>{item.bill_no}</Text>
              <Text style={getColumnStyle("partyName")}>
                {item.party_name || "N/A"}
              </Text>
              <Text style={getColumnStyle("gstNo")}>
                {item.gst_no || "N/A"}
              </Text>

              <Text style={getColumnStyle("billAmount")}>
                {parseFloat(item.total).toFixed(2)}
              </Text>
              <Text style={getColumnStyle("gstAmount")}>
                {item.gst_amount || "0.00"}
              </Text>

              {/* Last column isLast=true to remove right border */}
              <Text style={getColumnStyle("toAmount", true)}>
                {(
                  parseFloat(item.total || 0) + parseFloat(item.gst_amount || 0)
                ).toFixed(2)}
              </Text>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default SalesInvoicePdfList;
